<template>
  <v-navigation-drawer
    permanent
    fixed
    app
    width="250"
    ref="side-nav"
  >
    <v-sheet color="white" class="pa-5">
      <v-img :src="require('@/assets/logo.svg')" contain></v-img>
    </v-sheet>
    <v-list nav class="primary--text">
      <v-list-item class="text-center title secondary" light>
        <v-list-item-content>
          <v-list-item-title>
            Portail Analytique
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-3"></v-divider>
      <v-list-group>
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{user.firstName}} {{user.lastName}}</v-list-item-title>
            <v-list-item-subtitle>{{user.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
        <v-list-item @click="changingPassword = true">
          <v-list-item-action>
            <v-icon>vpn_key</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            Changer de mdp
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="disconnectUser">
          <v-list-item-action>
            <v-icon>logout</v-icon>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t('Menu.Topbar.logout') }}
          </v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-divider class="my-3"></v-divider>

      <template v-for="(item, index) in items">
        <v-list-item :key="'item' + index" :to="item.to">
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <v-divider class="my-3"></v-divider>

    <LimitDate />
    <UserCounter />
    <UserPasswordFormModal :show="changingPassword" @close="changingPassword = false" />
  </v-navigation-drawer>
</template>

<script>
import {mapState, mapGetters, mapActions} from 'vuex'
import routeNames from '@/router/routeNames'
import UserPasswordFormModal from '@/components/User/UserPasswordFormModal'
import UserCounter from '@/components/License/UserCounter'
import LimitDate from '@/components/License/LimitDate'

export default {
  name: 'TheSideBar',
  components: {UserCounter, UserPasswordFormModal, LimitDate },
  data: () => ({
    changingPassword: false
  }),
  computed: {
    ...mapState('auth', [
      'user'
    ]),
    ...mapGetters('auth', [
      'picturePath'
    ]),
    items() {
      return [
        { icon: 'store', text: this.$t('Menu.Sidebar.brands'), to: {name: routeNames.brands} },
        { icon: 'domain', text: this.$t('Menu.Sidebar.malls'), to: {name: routeNames.malls} },
        { icon: 'perm_media', text: this.$t('Menu.Sidebar.news'), to: {name: routeNames.news} },
        { icon: 'folder_open', text: this.$t('Menu.Sidebar.documents'), to: {name: routeNames.documents} },
        { icon: 'keyboard', text: this.$t('Menu.Sidebar.entries'), to: {name: routeNames.entries} },
        { icon: 'supervised_user_circle', text: this.$t('Menu.Sidebar.users'), to: {name: routeNames.users} }
      ]
    },
  },
  methods: {
    ...mapActions('auth', [
      'disconnectUser'
    ])
  }
}
</script>
